<app-admin-header></app-admin-header>

<div class="content-wrapper my-5 p-t-25 dis-flex">
  <div class="main-content p-t-20">
    <div class="container-fluid" style="height: calc(100vh - 20vh)">
      <app-breadcrumb
        [items]="[{ label: 'Admin' }, { label: 'Users' }]"
        [home]="{ label: 'Home', routerLink: '/home' }"
      ></app-breadcrumb>

      <div class="m-b-20 dis-flex flex-sb">
        <div>
          <h1 class="font-medium text-70 m-b-0">Users</h1>
        </div>
        <div class="search-box-wrapper">
          <ng-icon
            name="hugeSearch01"
            size="16"
            class="m-r-5 lh-1-0 text-70"
          ></ng-icon>
          <input
            class="radius-8 b2 wd-500px"
            type="text"
            [(ngModel)]="searchText"
            placeholder="Search by User / Designation"
            (input)="filterUsers()"
          />
        </div>
        <div class="dis-flex">
          <button
            class="btn outline b2 wd-120px mx-2"
            (click)="exportUsers()"
            [disabled]="isDownloading"
          >
            <ng-icon class="lh-1-0 m-r-4" name="hugeDownload03" size="18" />
            <span *ngIf="isDownloading">Downloading...</span>
            <span *ngIf="!isDownloading">Download</span>
          </button>
          <button class="btn primary b2 wd-120px" (click)="addUserModal()">
            <ng-icon class="lh-1-0 m-r-4" name="hugeAdd01" size="18" />Add User
          </button>
        </div>
      </div>

      <!-- <div class="content">
        <p-table class="scrollable-table" #dt [value]="users" styleClass="p-datatable-striped"
          [globalFilterFields]="['name']" [tableStyle]="{ 'min-width': '50rem' }" scrollable="true"
          [scrollHeight]="scrollHeight">
          <ng-template pTemplate="caption">
            <div class="search-box-wrapper">
              <ng-icon name="hugeSearch01" size="16" class="m-r-5 lh-1-0 text-70"></ng-icon>
              <input class="radius-8 b2 m-r-20" type="text" pInputText
                (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                placeholder="Search by User / Designation" />
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>User</th>
              <th>Designation</th>
              <th>Manager</th>
              <th>Groups</th>
              <th>Active</th>
              <th>Edit</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-user>
            <tr>
              <td>
                <div class="user-info">
                  <div>
                    <img class="user-img" src="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png" />
                  </div>
                  <div>
                    <p class="b3 mb-0">{{ user.name }}</p>
                    <p class="b2 mb-0">{{ user.email }}</p>
                  </div>
                </div>
              </td>
              <td>{{ user.designation }}</td>
              <td>{{ user.manager?.name || '-' }}</td>
              <td></td>
              <td>
                <p-checkbox [(ngModel)]="user.status" [binary]="true" variant="filled" (click)="changeStatus(user)" />
              </td>
              <td>
                <button type="button" class="icon-btn" pRipple (click)="selectUser(user, userForm);">
                  <ng-icon name="hugeEdit02" class="m-t-8"></ng-icon>
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div> -->

      <div class="content">
        <div class="table-container">
          <app-virtual-scroll
            class="w-full"
            [data]="userPayload"
            [apiUrl]="userUrl"
            (loadedData)="onDataLoaded($event)"
          >
            <ng-container *ngIf="!isLoading; else loadingData">
              <table class="scrollable-table">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Designation</th>
                    <th>Manager</th>
                    <th>Groups</th>
                    <th class="text-center">Active</th>
                    <th class="text-center">Edit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of users">
                    <td>
                      <div class="user-info">
                        <img
                          class="user-img radius-4"
                          [src]="user.avatar || helper.defaultImageUrl"
                        />
                        <div>
                          <p class="b3 mb-0">{{ user.name }}</p>
                          <p class="b2 mb-0">{{ user.email }}</p>
                        </div>
                      </div>
                    </td>
                    <td>{{ user.designation }}</td>
                    <td>{{ user.manager?.name || "-" }}</td>
                    <td>
                      <span *ngIf="user.groups.length > 0">
                        <span
                          *ngFor="
                            let group of user.groups.slice(0, 1);
                            let last = last
                          "
                        >
                          {{ group?.group?.name }}<span *ngIf="!last">, </span>
                        </span>
                        <span
                          class="m-l-10 badge rounded-pill bg-light border p-2 text-secondary shadow-sm"
                          *ngIf="user.groups.length > 1"
                          [ngbTooltip]="getGroupNames(user.groups)"
                          placement="bottom"
                        >
                          {{ "+" + (+user.groups.length - 1) }}
                        </span>
                      </span>
                      <span *ngIf="!user.groups?.length">-</span>
                    </td>
                    <td class="text-center">
                      <p-checkbox
                        [(ngModel)]="user.status"
                        [binary]="true"
                        variant="filled"
                        (onChange)="changeStatus(user, $event.checked)"
                      >
                      </p-checkbox>
                    </td>

                    <td class="text-center">
                      <button
                        type="button"
                        class="icon-btn"
                        (click)="openUserModal(user)"
                      >
                        <ng-icon name="hugeEdit02" class="m-t-8"></ng-icon>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="users.length < 1">
                    <td colspan="6">
                      <app-no-data-found [imageWidth]="30"></app-no-data-found>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </app-virtual-scroll>
        </div>
      </div>

      <app-admin-users-model
        *ngIf="isUserModalVisible"
        [isEdit]="isEdit"
        (closeUserModal)="closeUserModal($event)"
        [isUserModalVisible]="isUserModalVisible"
        [userData]="selectedUser"
      ></app-admin-users-model>
    </div>
  </div>
</div>

<ng-template #noDataFound>
  <img src="assets/images/no_data_found.png" width="400" height="450" />
</ng-template>

<ng-template #loadingData>
  <app-shimmer-list></app-shimmer-list>
</ng-template>
